import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Shield } from "lucide-react";

const accidentTypes = [
  ["Car Accidents", "/accident-types/car-accidents"],
  ["Truck Accidents", "/accident-types/truck-accidents"],
  ["Motorcycle", "/accident-types/motorcycle-accidents"],
  ["Pedestrian", "/accident-types/pedestrian-accidents"],
  ["Uber & Lyft", "/accident-types/uber-lyft-accidents"],
  ["Drunk Driving", "/accident-types/drunk-driving-accidents"],
  ["Slip & Fall", "/accident-types/slip-and-fall"],
  ["Wrongful Death", "/accident-types/wrongful-death"],
];

const cities = [
  ["Cleveland", "/ohio-cities/cleveland"],
  ["Columbus", "/ohio-cities/columbus"],
  ["Cincinnati", "/ohio-cities/cincinnati"],
  ["Akron", "/ohio-cities/akron"],
  ["Toledo", "/ohio-cities/toledo"],
  ["Dayton", "/ohio-cities/dayton"],
  ["Parma", "/ohio-cities/parma"],
  ["Canton", "/ohio-cities/canton"],
];

export default function Footer() {
  return (
    <footer className="bg-forest text-bone mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-terracotta grid place-items-center text-white font-display font-black text-lg">O</div>
              <div className="font-display font-bold text-bone text-lg tracking-tight">Ohio Accident Aid</div>
            </div>
            <p className="text-bone/70 text-sm max-w-xs leading-relaxed mb-6">
              Free, 24/7 help for accident victims across Ohio. We connect you with experienced local
              attorneys who fight for what you deserve. No fees unless you win.
            </p>
            <div className="space-y-2 text-sm text-bone/80">
              <a href="tel:12162455967" className="flex items-center gap-2 hover:text-terracotta transition" data-testid="footer-phone">
                <Phone className="w-4 h-4 shrink-0" /> (216) 245-5967
              </a>
              <div className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0" /> Use the case review form</div>
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 shrink-0" /> Serving all of Ohio</div>
            </div>
          </div>

          <div>
            <div className="text-bone font-display font-bold text-base mb-4">Accident Types</div>
            <ul className="space-y-2">
              {accidentTypes.map(([name, href]) => (
                <li key={href}>
                  <Link to={href} className="text-sm text-bone/70 hover:text-terracotta transition">{name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-bone font-display font-bold text-base mb-4">Ohio Cities</div>
            <ul className="space-y-2">
              {cities.map(([name, href]) => (
                <li key={href}>
                  <Link to={href} className="text-sm text-bone/70 hover:text-terracotta transition">{name}</Link>
                </li>
              ))}
              <li>
                <Link to="/ohio-cities" className="text-sm text-terracotta font-semibold hover:underline">View all cities →</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-bone/10 mt-12 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-bone/60">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4" />
            © {new Date().getFullYear()} Ohio Accident Aid. All rights reserved.
          </div>
          <div className="leading-relaxed max-w-2xl">
            Disclaimer: This site is not a law firm and does not provide legal advice. We connect
            visitors with independent attorneys for free, no-obligation consultations. Contacting us
            does not create an attorney-client relationship. Past results do not guarantee future
            outcomes.
          </div>
        </div>
      </div>
    </footer>
  );
}
